'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _utils = require('../utils');

var _functional = require('../utils/functional');

function init(_ref) {
  var el = _ref.el;

  var scrollToButton = el;
  var scrollToSelector = scrollToButton.dataset.scrollTo;
  var headerHeight = (0, _functional.getElement)('.js-Header').offsetHeight;

  scrollToButton.addEventListener('click', function () {
    var scrollToElement = (0, _functional.getElement)(scrollToSelector);
    var offsetTopElem = scrollToSelector === 'body' ? 0 : (0, _utils.getOffsetTop)(scrollToElement);
    var scrollDistance = offsetTopElem - headerHeight;

    (0, _utils.scrollToY)(scrollDistance);
  });
}